// Widget-specific mini tours for section help icons

interface TourStep {
  target: string;
  content: string;
  title?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'center';
}

export const NORTH_INDIAN_CHART_TOUR: TourStep[] = [
  {
    target: '[data-tour="north-indian-chart"]',
    title: 'North Indian Chart',
    content: 'This diamond-shaped chart shows the 12 houses (bhavas) with planets positioned in their respective houses. The ascendant (Lagna) is always at the top.',
    placement: 'right',
  },
];

export const DASHA_TOUR: TourStep[] = [
  {
    target: '[data-tour="vimshottari-dasha"]',
    title: 'Vimshottari Dasha',
    content: 'The Vimshottari Dasha system divides your 120-year life span into planetary periods. Your current Mahadasha (main period), Antardasha (sub-period), and Pratyantardasha are highlighted.',
    placement: 'right',
  },
];

export const VARGA_TOUR: TourStep[] = [
  {
    target: '[data-tour="shodasha-varga"]',
    title: 'Divisional Charts',
    content: 'Divisional charts (D1-D60) reveal deeper insights. D9 shows marriage, D10 career, D24 education. Each varga has specific life area significance in Vedic astrology.',
    placement: 'right',
  },
];

export const PLANET_STRENGTH_TOUR: TourStep[] = [
  {
    target: '[data-tour="planet-strength"]',
    title: 'Planet Strength',
    content: 'Shadbala measures six-fold strength. Ishta shows favorable results, Kashta shows challenges. The blended score combines both to show overall planet effectiveness.',
    placement: 'right',
  },
];

export const BASIC_DETAILS_TOUR: TourStep[] = [
  {
    target: '[data-tour="basic-details"]',
    title: 'Basic Chart Details',
    content: 'View your ascendant (Lagna), moon sign (Rashi), birth nakshatra, and planetary dignities (exalted/debilitated/combust planets).',
    placement: 'bottom',
  },
];

export const YOGAS_TOUR: TourStep[] = [
  {
    target: '[data-tour="yogas"]',
    title: 'Yogas & Combinations',
    content: 'Classical yogas are special planetary combinations that indicate specific life outcomes. Raj yogas bring success, Dhana yogas bring wealth, Arishta yogas indicate challenges.',
    placement: 'bottom',
  },
];

// Map widget types to their tours
export const WIDGET_TOURS: Record<string, TourStep[]> = {
  'north-indian-chart': NORTH_INDIAN_CHART_TOUR,
  'vimshottari-dasha': DASHA_TOUR,
  'shodasha-varga': VARGA_TOUR,
  'planet-strength': PLANET_STRENGTH_TOUR,
  'basic-details': BASIC_DETAILS_TOUR,
  'yogas': YOGAS_TOUR,
};
